module.exports = {"id":"204077","name":"M'Baye Niang","rating":"77","photo":"./data/images/photos/3/204077.png","club":{"name":"Torino","logo":"./data/images/clubs/Torino.png"},"positions":["AG","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/M'BayeNiang0.json
// module id = 2648
// module chunks = 0